<template>
  <div
    class="icon-text-button d-flex align-items-center"
    :class="{ active }"
    @click="onClick">
    <span
      class="icon-text-button__icon mr-1"
      :class="outlined ? 'material-icons-outlined' : 'material-icons'"
      :style="{ fontSize: `${iconSize}px` }">
      {{ icon }}
    </span>
    <span class="icon-text-button__text">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null,
    },
    outlined: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }

}
</script>

<style lang="scss" scoped>
.icon-text-button {
  color: $grey05;
  cursor: pointer;
  width: fit-content;

  &.active {
    color: $l-blue;
  }

  &__icon {
    font-size: $fs-xl;
  }

  &__text {
    font-size: $fs-m;
  }
}

</style>